import { QRAGraphType } from '..'

const nameMapping = {
  [QRAGraphType.THREATS]: 'Threats',
  [QRAGraphType.CONSEQUENCES]: 'Consequences',
  [QRAGraphType.RISK_BY_LINE]: 'Risk By Line',
  [QRAGraphType.LINEAR_REFERENCE]: 'Linear Reference',
  [QRAGraphType.RISK_FORECAST]: 'Risk Forecast',
  [QRAGraphType.RISK_BY_SIGNIFICANCE_LEVEL]: 'Risk by Significance Level',
  [QRAGraphType.RISK_LEVEL_BY_OUTCOME_SCENARIO]:
    'Risk Level by Outcome Scenario',
  [QRAGraphType.RISK_BY_RELEASE_TYPE]: 'Risk by Release Type',
  [QRAGraphType.RISK_BY_SYSTEM]: 'Risk by System',
  [QRAGraphType.RISK_BY_CONSEQUENCE_AREAS]: 'Risk by Consequence Areas'
}

export const graphTypeToName = (graphType: QRAGraphType): string => {
  const graphName = nameMapping[graphType]

  if (graphName != null) {
    return graphName
  }

  return 'Undefined'
}
